import React from "react";
import IcomoonReact from "icomoon-react";
import iconSet from "./selection.json";

const Icon = ({ color = "currentColor", size = "1.25rem", icon, className = "" }) => {
    if (!icon) return null;

    return (
        <IcomoonReact
            className={className}
            iconSet={iconSet}
            color={color}
            size={size}
            icon={icon}
        />
    );
};

export default Icon;
